import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../components/scalify-views/Dashboard.vue'
import Accounts from '../components/scalify-views/Accounts.vue'
import Autopilot from '../components/scalify-views/Autopilot.vue'
import Reviews from '../components/scalify-views/Reviews.vue'
import AutopilotDetails from '../components/scalify-views/AutopilotDetails.vue'
import Affiliates from '../components/scalify-views/Affiliates.vue'
import Tasks from '../components/scalify-views/Tasks.vue'
import Errors from '../components/scalify-views/Errors.vue'
import Login from '../components/scalify-views/Login.vue'
import AccountDetails from '../components/scalify-views/AccountDetails.vue'
import AffiliateDetails from '../components/scalify-views/AffiliateDetails.vue'
import TaskDetails from '../components/scalify-views/TaskDetails.vue'
import PlansAndCoupon from '../components/scalify-views/PlansAndCoupon.vue'
// import Components from '../components/scalify-views/AllComponents.vue'

Vue.use(VueRouter)

const routes = [

  { path: '/login', name: 'Login', meta:{ layout:"no-sidebar"}, component: Login },
  { path: '/', name: 'Dashboard', component: Dashboard },
  { path: '/account/:id', name: 'account-details', component: AccountDetails },
  { path: '/account/task/:id', name: 'account-task-details', component: TaskDetails },
  { path: '/tasks', name: 'Tasks', component: Tasks },
  { path: '/tasks/task/:id', name: 'tasks-task-details', component: TaskDetails },
  { path: '/tasks/account/:id', name: 'tasks-account-details', component: AccountDetails },

  { path: '/accounts', name: 'Accounts', component: Accounts },
  { path: '/affiliates', name: 'Affiliates', component: Affiliates },
  { path: '/affiliates/:id', name: 'affiliates-details', component: AffiliateDetails },

  { path: '/reviews', name: 'reviews', component: Reviews },

  { path: '/autopilot', name: 'Autopilot', component: Autopilot },
  { path: '/autopilot/:id', name: 'Autopilot-details', component: AutopilotDetails },

  { path: '/plans', name: 'Plans', component: PlansAndCoupon },

  { path: '/errors', name: 'Errors', component: Errors },


  // { path: '/components', name: 'Components', component: Components }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
